<template>
  <div>
    <el-button type="primary" icon="el-icon-plus" @click="editShow = true"
      >添加交易区</el-button
    >

    <el-table :data="tradeRangeList">
      <el-table-column label="交易区英文名称" prop="name" />
      <el-table-column label="交易区中文名称" prop="nameZh" />
      <el-table-column label="交易区code" prop="code" />
      <el-table-column label="交易区等级">
        <template slot-scope="scope">
          <span v-if="scope.row.level == 1">一级交易区</span>
          <span v-if="scope.row.level == 2">二级交易区</span>
        </template>
      </el-table-column>
      <el-table-column label="Icon中文">
        <template slot-scope="scope"><img :src="scope.row.iconZh" /></template>
      </el-table-column>
      <el-table-column label="Icon英文">
        <template slot-scope="scope"><img :src="scope.row.iconEn" /></template>
      </el-table-column>
      <el-table-column label="是否虚拟交易区">
        <template slot-scope="scope">{{
          scope.row.virtual ? "是" : "否"
        }}</template>
      </el-table-column>
      <el-table-column label="排序" prop="orderNo"></el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            @click="alterInfo(scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            @click="removeTrade(scope.row.code)"
          ></el-button>
          <el-button type="text" @click="sortTrade(scope.row.code)"
            >排序</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="10"
      :current-page="queryCondition.page"
      @current-change="queryTradeRangeList"
    ></el-pagination>

    <el-dialog title="交易区信息" :visible.sync="editShow" @close="closeDialog">
      <el-form label-width="150px" :model="editInfo" ref="tradeForm">
        <el-form-item
          label="交易区code"
          prop="code"
          :rules="[
            { required: true, message: '交易区code不能为空', trigger: 'blur' },
          ]"
        >
          <el-input
            v-model="editInfo.code"
            :disabled="opType !== ''"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="交易区英文名称"
          prop="name"
          :rules="[
            { required: true, message: '交易区名称不能为空', trigger: 'blur' },
          ]"
        >
          <el-input v-model="editInfo.name" />
        </el-form-item>
        <el-form-item label="交易区中文名称" prop="nameZh">
          <el-input v-model="editInfo.nameZh" />
        </el-form-item>
        <el-form-item label="交易区等级">
          <el-select v-model="editInfo.level">
            <el-option
              v-for="item in tradeLevels"
              :key="item.code"
              :label="item.desc"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="父级交易区code" v-if="editInfo.level === 2">
          <!-- <el-input v-model="editInfo.supCode"></el-input> -->
          <el-select v-model="editInfo.supCode">
            <el-option
              v-for="item in fristList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Icon 中文">
          <upload
            v-model="editInfo.iconZh"
            :data="{ language: 1, platform: 1 }"
          ></upload>
        </el-form-item>
        <el-form-item label="Icon 英文">
          <upload
            v-model="editInfo.iconEn"
            :data="{ language: 4, platform: 1 }"
          ></upload>
        </el-form-item>
        <el-form-item label="是否虚拟交易区" v-if="editInfo.level === 1">
          <el-radio-group v-model="editInfo.isVirtual">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submitInfo">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import "./store";
import api from "./api";
import upload from "../../../components/upload";
export default {
  name: "tradeRange",
  components: { upload },
  data() {
    return {
      editShow: false,
      opType: "",
      fristList: [],
      queryCondition: { page: 1, size: 10 },
      editInfo: {
        name: "",
        nameZh: "",
        code: "",
        iconZh: "",
        iconEn: "",
        isVirtual: true,
        level: 1,
        supCode: "",
      },
      tradeLevels: [
        { code: 1, desc: "一级交易区" },
        { code: 2, desc: "二级交易区" },
      ],
    };
  },
  computed: {
    ...mapState("tradeRange", ["totalCount", "tradeRangeList"]),
  },
  methods: {
    ...mapActions("tradeRange", ["findTradeRangeList"]),
    closeDialog() {
      this.editInfo = {};
      this.opType = "";
      this.$refs["tradeForm"].resetFields();
      this.editShow = false;
    },
    queryTradeRangeList(val) {
      this.queryCondition.page = val;
      this.findTradeRangeList(this.queryCondition);
    },
    alterInfo(info) {
      let editInfo = JSON.parse(JSON.stringify(info));
      editInfo.isVirtual = info.virtual;
      this.editInfo = editInfo;
      this.opType = "update";
      this.editShow = true;
    },
    submitInfo() {
      this.$refs["tradeForm"].validate((valid) => {
        if (valid) {
          if (this.editInfo.level === 2 && !this.editInfo.supCode) {
            this.$message.error("请输入父级交易区code");
            return;
          }
          if (this.editInfo.level === 2) {
            this.editInfo.isVirtual = false;
          }
          if (this.opType) {
            api.updateTradeRange(this.editInfo).then(() => {
              this.$message.success("修改成功");
              this.queryTradeRangeList(1);
              this.closeDialog();
              this.opType = "update";
            });
          } else {
            if (!/^[0-9a-zA-Z]{1,20}$/.test(this.editInfo.code)) {
              this.$message.error("交易区code不能为中文");
              return;
            }
            api.createTradeRange(this.editInfo).then(() => {
              this.$message.success("新增成功");
              this.queryTradeRangeList(1);
              this.closeDialog();
              this.opType = "";
            });
          }
        }
      });
    },
    removeTrade(code) {
      this.$confirm("确认删除改交易区设置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.removeTradeSet({ code: code }).then(() => {
            this.$message.success("删除成功");
            this.queryTradeRangeList(1);
            this.closeDialog();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    sortTrade(code) {
      this.$prompt("请输入排列序号数字", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: "",
      })
        .then(({ value }) => {
          api.sortTradeSet({ code: code, orderNo: value }).then(() => {
            this.$message.success("排序成功");
            this.queryTradeRangeList(1);
            this.closeDialog();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    queryFristList(){  
      api.listTradeRange({page: 1, size: 999, level: 1}).then((res)=> {
        this.fristList = res.data
      })
    },
  },
  created() {
    this.queryTradeRangeList(1);
    this.queryFristList()
  },
};
</script>

<style scoped>
</style>
